import { createContext, useContext } from 'react';
import { getEmbeddedJson } from '@/utils/getEmbeddedJson';
import { JsonScriptId } from '@/constants';
import type { ProviderProps } from './types';

interface AgeRange {
  code: string;
  label: string;
}

interface AlgoliaConfig {
  applicationId: string;
  searchApiKey: string;
  productIndex: string;
  productIndexAlphabeticalAsc: string;
  productIndexAlphabeticalDesc: string;
  productIndexPriceAsc: string;
  productIndexPriceDesc: string;
}

export interface SearchData {
  algolia: AlgoliaConfig;
  ageRanges: AgeRange[];
  showingResultsForLabel: string;
  defaultPromotionBadge: string;
  nextDayDeliveryThreshold: number;
  nextDayDeliveryMessage: string;
  showMoreLikeThis?: boolean;
}

const SearchContext = createContext<SearchData | null>(null);

export const SearchDataProvider = ({ children }: ProviderProps) => {
  const searchData: SearchData = getEmbeddedJson(JsonScriptId.Search);
  return (
    <SearchContext.Provider value={searchData}>{children}</SearchContext.Provider>
  );
};

export const useSearchData = () => {
  const context = useContext(SearchContext);

  if (context === undefined || context === null) {
    throw new Error('useSearchData must be used within a SearchDataProvider');
  }

  return context;
};
